import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import { ImgBackCardOne } from "../../../assets/logos/icons";
import { EffectFade, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css/bundle';
import "./cardSwiperHL.css";
import { useMediaQuery } from "@material-ui/core";
import { useEffect } from "react";

const CardSwiperHLPure = (props) => {
  const {
    cardSwiperData,
  } = props;

  const desiredWidth = 194 * (cardSwiperData.length + 1);
  const mobileResolution = useMediaQuery(`(max-width:${desiredWidth}px)`);
  const [show, setShow] = useState(cardSwiperData.length)

  const handleResize = () => {
    let width = window.outerWidth < window.innerWidth ? window.outerWidth : window.innerWidth;
    let fits = Math.floor(width / 194);
    if (fits - 1 != show) {
      setShow(fits - 1)
    };
  }

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize);
    }
  }, [])

  return (
    <>
      {mobileResolution === true ? (
        <Swiper
          // effect={"fade"}
          // slidesPerView={5}
          // spaceBetween={20}
          modules={[EffectFade, Navigation]}
          className="mySwiper"
          pagination={{
            clickable: true,
          }}
          slidesPerView={show}
        >
          <div>
            {cardSwiperData.map((slideContent, index) => (
              <div
                {...slideContent}
                key={slideContent.title}
              // value={index.name}
              >
                <SwiperSlide>
                  <div className={"cardSwiperHL-container "}>
                    <Link to={slideContent.url}>
                      <div className="cardSwiperHL-img-container">
                        {slideContent.imgBackCard ? (
                          <img
                            src={slideContent.imgBackCard}
                            className="cardSwiperHL-img-background"
                          />
                        ) : (
                          <img
                            src={ImgBackCardOne}
                            className="cardSwiperHL-img-background"
                          />
                        )}
                        <img
                          className="cardSwiperHL-icon"
                          alt={slideContent.altImg}
                          src={slideContent.img}
                        />
                      </div>
                      <div className="cardSwiperHL-text-card-container">
                        <h3 className="cardSwiperHL-title-card">
                          {slideContent.title}
                        </h3>
                        <p
                          className={
                            slideContent.text2 || slideContent.text3
                              ? "cardSwiperHL-texts-first"
                              : "cardSwiperHL-text-description"
                          }
                        >
                          {slideContent.text}
                        </p>
                        {slideContent.text2 ? (
                          <p className="cardSwiperHL-texts-others">
                            {slideContent.text2}
                          </p>
                        ) : (
                          ""
                        )}
                        {slideContent.text3 ? (
                          <p className="cardSwiperHL-texts-others">
                            {slideContent.text3}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </Link>
                  </div>{" "}
                </SwiperSlide>
              </div>
            ))}
          </div>
        </Swiper>
      ) : (
        <div className="cardSwiperHL-inactive">
          {cardSwiperData.map((slideContent, index) => (
            <Link to={slideContent.url}>
              <Grid
                className="cardSwiperHL-container"
                {...slideContent}
                key={slideContent.title}
              >
                <div className="cardSwiperHL-img-container">
                  {slideContent.imgBackCard ? (
                    <img
                      src={slideContent.imgBackCard}
                      className="cardSwiperHL-img-background"
                    />
                  ) : (
                    <img
                      src={ImgBackCardOne}
                      className="cardSwiperHL-img-background"
                    />
                  )}
                  {slideContent.img ? (
                    <img
                      className="cardSwiperHL-icon"
                      alt={slideContent.altImg}
                      src={slideContent.img}
                    />
                  ) : null}
                </div>
                <div className="cardSwiperHL-text-card-container">
                  <h3 className="cardSwiperHL-title-card">
                    {slideContent.title}
                  </h3>
                  <p
                    className={
                      slideContent.text2 || slideContent.text3
                        ? "cardSwiperHL-texts-first"
                        : "cardSwiperHL-text-description"
                    }
                  >
                    {slideContent.text}
                  </p>
                  {slideContent.text2 ? (
                    <p className="cardSwiperHL-texts-others">
                      {slideContent.text2}
                    </p>
                  ) : (
                    ""
                  )}
                  {slideContent.text3 ? (
                    <p className="cardSwiperHL-texts-others">
                      {slideContent.text3}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </Grid>
            </Link>
          ))}
        </div>
      )}
    </>
  );
};

export { CardSwiperHLPure as default };
